/**
 * Pathology summary flow (Cellosign iframe, document blocks, polling).
 * Set to true when ready to release.
 */
export const PATHOLOGY_SUMMARY_ENABLED = false;

/**
 * IVF treatment list table (/table/ivf), menu entry, and table actions.
 * Set to true when ready to release.
 */
export const IVF_TREATMENT_LIST_ENABLED = false;

/**
 * Exception committee flow (וועדת חריגים) - menu entry, surgery dots menu,
 * surgery summary action and the /cellosign-iframe/exception-committee route.
 * Set to true when ready to release.
 */
export const EXCEPTION_COMMITTEE_ENABLED = false;
